import createIcon from '../../createIcon';

/**
 * @component @name HeartBroken
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAzQzE1LjU0IDMgMTQuNiAzLjI1IDEzLjc3IDMuNjlMMTIgOUgxNUwxMiAxOUwxMyAxMEgxMEwxMS41NCA0LjYxQzEwLjQ3IDMuNjEgOS4wMSAzIDcuNSAzQzQuNDIgMyAyIDUuNDIgMiA4LjVDMiAxMi42MyA2LjE2IDE1LjY4IDEyIDIxQzE3LjQ3IDE2LjA2IDIyIDEyLjc0IDIyIDguNUMyMiA1LjQyIDE5LjU4IDMgMTYuNSAzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HeartBroken = createIcon('HeartBroken', [
  [
    'path',
    {
      d: 'M16.5 3C15.54 3 14.6 3.25 13.77 3.69L12 9H15L12 19L13 10H10L11.54 4.61C10.47 3.61 9.01 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.63 6.16 15.68 12 21C17.47 16.06 22 12.74 22 8.5C22 5.42 19.58 3 16.5 3Z',
      key: '1yojce',
    },
  ],
]);

export default HeartBroken;
